module.exports = __webpack_public_path__ + "static/media/quote-img.ff4fcd8a.jpg";